import { render, staticRenderFns } from "./LprTriggerEntryHistory.vue?vue&type=template&id=1352a239&"
import script from "./LprTriggerEntryHistory.vue?vue&type=script&lang=js&"
export * from "./LprTriggerEntryHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports